import { environment } from 'src/environments/environment';

/**
 * Brand logos served from the static CDN (environment.staticCDN).
 * Temporary PNGs; swap the filenames here when the SVG versions land.
 */
export const BRAND_ASSETS = {
  /** Stacked shield + white wordmark, for dark backgrounds */
  logoShieldOnDark: `${environment.staticCDN}/img/adn_logo_shield.png`,
  /** Stacked shield + navy wordmark, for light backgrounds */
  logoShieldOnLight: `${environment.staticCDN}/img/adn_logo_shield_light.png`,
  /** Stacked shield + navy/red wordmark on transparent, for light backgrounds */
  logo: `${environment.staticCDN}/img/adn_logo.png`,
  /** Square app icon on a white tile */
  appIcon: `${environment.staticCDN}/img/app_icon.png`,
} as const;
